import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { UpdateDeviceAliasParams } from '@repo/user-types'

const initialUpdateDeviceAliasState: GenericOperationState<null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: updateDeviceAliasActions, reducer: updateDeviceAliasReducer } =
  createOperationSlice<
    null,
    SliceCaseReducers<GenericOperationState<null>>,
    UpdateDeviceAliasParams
  >({
    name: '@users/devices/update-alias',
    initialState: initialUpdateDeviceAliasState,
    reducers: {},
  })
